import { supportedLocales, } from '@tymia/main-api';
// use lowercase to match the url prefix, e.g. /de-de/
const locales = supportedLocales().map(locale => ({
    locale,
    localeLower: locale.toLowerCase(),
}));
function findLocale(value) {
    if (!value)
        return undefined;
    const lower = value.toLowerCase();
    return locales.find(l => l.localeLower === lower)?.locale;
}
export function splitLocale(pathname) {
    const parts = pathname.split('/').filter(Boolean);
    const first = parts[0];
    const locale = findLocale(first);
    if (!locale) {
        return {
            pathname: pathname || '/',
        };
    }
    const rest = '/' + parts.slice(1).join('/');
    return {
        locale,
        pathname: rest,
    };
}
export function addLocale(newLocale, url) {
    const { pathname } = splitLocale(url.pathname);
    url.pathname = `/${newLocale.toLowerCase()}${pathname === '/' ? '' : pathname}`;
    return url;
}
//# sourceMappingURL=localeRewrite.js.map